import { render, staticRenderFns } from "./fcwpVideo.vue?vue&type=template&id=55bf6422&"
import script from "./fcwpVideo.vue?vue&type=script&lang=js&"
export * from "./fcwpVideo.vue?vue&type=script&lang=js&"
import style0 from "./fcwpVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports